// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__p5QNm","noInteraction":"EventWrapper_noInteraction__1PXmu"};